import { PopupPosition } from 'vant/es/popup/types'

export type PopupInfo = {
  popupPosition: PopupPosition
  touchSlide?: string
  showDirection?: string
  positionTop?: number
  popupData: ItemInfo[][]
  actionUserInfo: object
}

export enum ugcType {
  DISLIKETA = 0, // 不喜欢ta
  NOTVIEWTA = 1, // 不看ta
  REPORTTA = 2, // 举报ta
  REPORTCOMMENT = 3, // 举报评论
  CANCELBUTTON = 4, // 取消按钮
}

export type ItemInfo = {
  icon: string
  title: string
  tips?: string
  arrow?: boolean
  type: ugcType
  layout?: string
}
